import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '@/features/account/pages/settings-page'

export type SettingsSection = 'general' | 'discovery' | 'permissions' | 'danger'

export interface SettingsSearch {
  /** A6 active section (sub-tab strip). */
  section?: SettingsSection
}

/** A6 — Workspace settings (General · Discovery · Permissions · Danger zone). */
export const Route = createFileRoute('/_ws/w/$workspaceId/settings')({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
    section:
      search.section === 'general' ||
      search.section === 'discovery' ||
      search.section === 'permissions' ||
      search.section === 'danger'
        ? search.section
        : undefined,
  }),
  component: SettingsPage,
})
